import { h } from 'preact';

export default ({ variant, user, session, modifierClass, mixpanelTracker }) => {
  const { pub } = window.reservamosPubSub;

  const signOut = () => session
    .signOut()
    .then(() => {
      mixpanelTracker.trackSignOut(user.sp_card);
      pub('siempreplus', {
        loading: false,
        user: null,
        error: false,
      });
    })
    .catch(console.warn);

  const isRegistered = user.customer_type === 'SPP';

  return variant === 'button' ? null : (
    <div>
      <div className={`user-info ${modifierClass}`}>
        <p className="user-info-title">
          <i className="user-info-icon" />
          <span>Hola </span>
          <b>{user.first_name}</b>
        </p>
        <div className="tooltip">
          <div className="user-nav">
            {isRegistered && (
              <div className="user-nav-row">
                <span className="user-nav-item">
                  {user.email}
                </span>
              </div>
            )}
            <div className="user-nav-row">
              {/* eslint-disable jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events */}
              {/* eslint-disable jsx-a11y/no-static-element-interactions */}
              <a className="user-nav-item">
                Numero de Socio:
                <span className="user-nav-data">{user.sp_card}</span>
              </a>
            </div>
            <div className="user-nav-row">
              <a className="user-nav-item">
                Kilometros:
                <span className="user-nav-data">{user.available_kms}</span>
              </a>
            </div>
            {/* aquí irá opción Ver perfil completo */}
            <div className="user-nav-row">
              <a className="user-nav-item" onClick={signOut}>
                Cerrar sesión
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/UserInfo.js